import React from 'react';
import PropTypes from "prop-types";
import {contentUtils, HTMLContent} from "mindsets-js-sdk";

function Row({item, row_number}) {
    const date = new Date(item.created_at * 1000);
    date.setUTCHours(0, 0, 0, 0);

    function renderDescription(option) {
        if (!option.description) {
            return null;
        }

        return (
            <div className="poll-option-image-description flex-row flex-vh-center center-align">
                <HTMLContent
                    html_str={contentUtils.processStringContent(option.description, {convert_spelling: false})}/>
            </div>
        );
    }

    function renderVote() {
        if (item.poll && Array.isArray(item.poll.poll_options)) {
            return (
                <div className='d-flex flex-gap-10 flex-wrap'>
                    {item.poll.poll_options.map(option => {
                        return (
                            <div className='d-flex flex-column align-items-center bordered flex-gap-10'>
                                <div className="poll-option-image-container">
                                    <img
                                        className="poll-option-image"
                                        src={option.option}
                                        alt=''
                                        style={{height: '50px'}}/>
                                    {renderDescription(option)}
                                </div>

                                <div className="poll-option-content-container">
                                    <div className="d-flex flex-nowrap flex-gap-5 align-items-center">
                                        <i className={'poll-option-radio far ' + (item.poll_option_id === option.id ? 'fa-dot-circle' : 'fa-circle')}></i>

                                        <div className="poll-option-title center-align">
                                            <HTMLContent
                                                html_str={contentUtils.processStringContent(option.title, {convert_spelling: false})}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            );
        }

        return null;
    }

    return (
        <tr key={item.id}>
            <td>{row_number}</td>
            <td style={{whiteSpace: 'nowrap'}}>
                <div>Vote ID: {item.id}</div>
                <div>{date.toISOString().substring(0, 10)}</div>
                <div>Stream ID: {item.stream_id}</div>
                <div>Class: {item.lesson.code}</div>
                <div>Challenge: {item.lesson.challenge_version.name}({item.lesson.challenge_version.challenge_code.code})</div>
            </td>
            <td style={{whiteSpace: 'nowrap'}}>
                <div>{item.stream.user.fname + ' ' + item.stream.user.lname}</div>
                <div>{item.stream.user.email}</div>
                <div>ID {item.stream.user.id}</div>
            </td>
            <td style={{wordBreak: 'break-word', color: !item.is_active ? 'lightgray' : ''}}>
                {renderVote()}
            </td>
        </tr>
    );
}

Row.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number.isRequired,
        poll_option_id: PropTypes.number.isRequired,
        poll_id: PropTypes.number.isRequired,
        stream: PropTypes.shape({
            user: PropTypes.shape({
                id: PropTypes.number.isRequired,
                email: PropTypes.string.isRequired,
                fname: PropTypes.string.isRequired,
                lname: PropTypes.string,
            }).isRequired,
        }).isRequired,
        created_at: PropTypes.number.isRequired,
        is_active: PropTypes.bool,
        lesson: PropTypes.shape({
            code: PropTypes.string.isRequired,
            challenge_version: PropTypes.shape({
                version: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                challenge_code: PropTypes.shape({
                    code: PropTypes.string.isRequired,
                }).isRequired,
            }).isRequired,
        }).isRequired,
    }).isRequired,
    row_number: PropTypes.number.isRequired,
};

export default Row;
